import { AnyObject } from "../../types/app.type";

export function getMapOf<T extends AnyObject, K extends keyof T>(
  array: T[],
  key: K,
  options?: { removeSelectedKey?: boolean },
): Map<T[K], T | Omit<T, K>> {
  const { removeSelectedKey } = options || {};
  const map = new Map<T[K], T | Omit<T, K>>();
  array.forEach((element) => {
    const valueOfKey = element[key];
    const { [key]: k, ...restProps } = element;
    map.set(valueOfKey, removeSelectedKey ? restProps : element);
  });
  return map;
}
